// extracted by mini-css-extract-plugin
export default {"card":"Card_card__5pouJ","cardImage":"Card_cardImage__IDZY8","cardHeader":"Card_cardHeader__6EwMt","cardBody":"Card_cardBody__oXRaw","btn":"Card_btn__iCmb1"};